<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="费用类型值" prop="costTypeValue">
            <dict-select
              filterable
              v-model="formData.costTypeValue"
              placeholder="请选择费用类型值"
              default
              :body="costTypeValueDictParams"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="费用值" prop="costItemValue">
            <dict-select
              filterable
              v-model="formData.costItemValue"
              placeholder="请选择费用值"
              default
              :body="costItemValueDictParams"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="备注说明" prop="costItemRemarks">
            <el-input
              clearable
              v-model="formData.costItemRemarks"
              placeholder="请输入备注说明"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    carrierCostItemCode: {
      type: String,
      default: () => '',
    },
    carrierCode: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      costItemLabelDictParams: { type: 'costItemLabel' },
      costItemValueDictParams: { type: 'costItemValue' },
      costTypeLabelDictParams: { type: 'costTypeLabel' },
      costTypeValueDictParams: { type: 'costTypeValue' },
      backDialogVisible: false,
      formData: { carrierCode: '' },
      rules: {
        costTypeValue: [
          { required: true, message: '请选择费用类型值', trigger: 'change' },
        ],
        costTypeLabel: [
          { required: true, message: '请选择费用类型名称', trigger: 'change' },
        ],
        costItemValue: [
          { required: true, message: '请选择费用值', trigger: 'change' },
        ],
        costItemLabel: [
          { required: true, message: '请选择费用名称', trigger: 'change' },
        ],
        costItemRemarks: [
          { max: 66, message: '备注说明 字数最多为66位', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.carrierCostItemCode) return
      this.$api
        .masterCarrierCostItemDetailApi({
          carrierCostItemCode: this.carrierCostItemCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      this.formData.carrierCode = this.carrierCode
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterCarrierCostItemSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
